import React from 'react';

const TimeSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <mask
                id="mask0_20_232"
                style={{maskType: "alpha"}}
                width="16"
                height="16"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
            >
                <path fill="#D9D9D9" d="M0 0H16V16H0z"></path>
            </mask>
            <g mask="url(#mask0_20_232)">
                <path
                    fill="#BEBCB9"
                    d="M10.2 11.133l.933-.933-2.466-2.467V4.667H7.333v3.6l2.867 2.866zM8 14.667a6.492 6.492 0 01-2.6-.525 6.732 6.732 0 01-2.117-1.425A6.733 6.733 0 011.858 10.6 6.492 6.492 0 011.333 8c0-.922.175-1.789.525-2.6a6.732 6.732 0 011.425-2.117c.6-.6 1.306-1.075 2.117-1.425A6.492 6.492 0 018 1.333c.922 0 1.789.175 2.6.525.811.35 1.517.825 2.117 1.425.6.6 1.075 1.306 1.425 2.117.35.811.525 1.678.525 2.6 0 .922-.175 1.789-.525 2.6a6.733 6.733 0 01-1.425 2.117c-.6.6-1.306 1.075-2.117 1.425a6.492 6.492 0 01-2.6.525z"
                ></path>
            </g>
        </svg>
    );
};

export default TimeSvg;